import { Routes } from '@angular/router';
import { AnalysisComponent } from './pages/analysis/analysis.component';
import { UnauthorizedComponent } from './pages/unauthorized/unauthorized.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { authGuard } from './guards/auth.guard';

export const routes: Routes = [
    { path: 'analysis/:evaluationId', component: AnalysisComponent, canActivate: [authGuard] },
    { path: 'unauthorized', component: UnauthorizedComponent },
    { path: '**', component: NotFoundComponent },
];
